











 










































const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateReflectionMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetroReflectionGroup",
      "kind": "LinkedField",
      "name": "reflectionGroup",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingId",
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReflectionGroupTitleEditor_reflectionGroup"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReflectionGroupVoting_reflectionGroup"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RetroReflection",
          "kind": "LinkedField",
          "name": "reflections",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DraggableReflectionCard_reflection"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DraggableReflectionCard_staticReflections"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ReflectionCard_reflection"
            },
            (v1/*: any*/),
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plaintextContent",
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isViewerDragging",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDropping",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isEditing",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RemoteReflectionDrag",
                  "kind": "LinkedField",
                  "name": "remoteDrag",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "dragUserId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isSpotlight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "dragUserName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RemoteReflection_reflection"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isViewerCreator",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "reflectionGroupId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerVoteCount",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReflectionGroupHeader_reflectionGroup"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleIsUserDefined",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isExpanded",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subColumnIdx",
              "storageKey": null
            }
          ]
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReflectionGroup_reflectionGroup"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "voteCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "unlockedStages",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNavigableByFacilitator",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreateReflectionPayload",
  "abstractKey": null
};
})();

(node ).hash = "df026a27ddc8b6d86cd3eacf362f8eba";

export default node;
